import { loginService } from "#modules/auth/infra/login.service";

export const loginMutation = () => ({
  mutationKey: ["login"],
  mutationFn: loginService,
});
